<div class="flex flex-row gap-2 p-2 pt-2">
    @if (isMobileScreen) {
        @for (segment of getSegments(); track segment.index; let index = $index) {
            @if (segment.url) {
                <div><a href="{{ segment.url }}" class="text-ponder-bright truncate">{{ segment.shortName }}</a></div>
            } @else {
                <div class="truncate">{{ segment.shortName }}</div>
            }

            @if (index < (getSegments()!.length - 1)) {
                <div> > </div>
            }
        }
    } @else {
        @for (segment of getSegments(); track segment.index; let index = $index) {
            @if (segment.url) {
                <div><a href="{{ segment.url }}" class="text-ponder-bright truncate">{{ segment.name }}</a></div>
            } @else {
                <div class="truncate">{{ segment.name }}</div>
            }

            @if (index < (getSegments()!.length - 1)) {
                <div> > </div>
            }
        }
    }
</div>